import React from 'react';
import Heading from '@tds/core-heading';
import PropTypes from 'prop-types';

import { formatPrice } from '../../../utils/utils';
import { getLocalizedStrings } from '../../../misc';

const OptikTv = ({ optikTv }) => {
  const {
    quoteSummary: {
      products: { telusOptikTv: summaryLabel },
      setTopBox,
      profileType,
      ratePlan,
      regularOffer,
      limitedTimeOffer,
      freeThemePack,
      extraThemePack,
      additionalThemePack,
      freeThemePacksHomeBase,
      extraThemePacksHomeBase,
      additionalThemePacksHomeBase,
      table: { qty, oneTimeCharges, monthlyCharges, total },
      mainSetTopBox,
      additionalSetTopBox
    }
  } = getLocalizedStrings();

  const {
    ratePlan: {
      value: ratePlanValue,
      qty: ratePlanQty,
      prices: { monthly: ratePlanMonthly, oneTime: ratePlanOneTime }
    } = {},
    mainSetTopBox: {
      value: mainSetTopBoxValue,
      qty: mainSetTopBoxQty,
      prices: { monthly: mainSetTopBoxMonthly, oneTime: mainSetTopBoxOneTime }
    } = {
      prices: {}
    },
    profile,
    limitedTimeOffers,
    regularOffers,
    additionalThemePacks,
    extraThemePacks,
    freeThemePacks,
    freeThemePacksHomeBased,
    extraThemePacksHomeBased,
    additionalThemePacksHomeBased,
    setTopBoxes,
    totalMonthly,
    totalOneTime,
    additionalSetTopBoxes
  } = optikTv || {};

  return (
    <>
      {optikTv && (
        <div style={{ overflowX: 'auto' }}>
          <Heading level="h3">{summaryLabel}</Heading>
          <br />
          <table>
            <thead>
              <tr>
                <th width="60%"></th>
                <th>{qty}</th>
                <th>{oneTimeCharges}</th>
                <th>{monthlyCharges}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {ratePlan}: {ratePlanValue}
                </td>
                <td>{ratePlanQty}</td>
                <td>{formatPrice(ratePlanOneTime)}</td>
                <td>{formatPrice(ratePlanMonthly)}</td>
              </tr>
              <tr>
                <td>
                  {profileType}: {profile}
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              {freeThemePacks &&
                freeThemePacks.length > 0 &&
                freeThemePacks.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`optikTvFreeThemePack${roValue}`}>
                      <td>
                        {freeThemePack}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
                {freeThemePacksHomeBased &&
                freeThemePacksHomeBased.length > 0 &&
                freeThemePacksHomeBased.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`telusOptikTvFreeThemePacksForHomeBased${roValue}`}>
                      <td>
                        {freeThemePacksHomeBase}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
              {additionalThemePacks &&
                additionalThemePacks.length > 0 &&
                additionalThemePacks.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`optikTvAdditionalThemePack${roValue}`}>
                      <td>
                        {additionalThemePack}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
                {additionalThemePacksHomeBased &&
                additionalThemePacksHomeBased.length > 0 &&
                additionalThemePacksHomeBased.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`telusOptikTvAdditionalThemePacksHomeBased${roValue}`}>
                      <td>
                        {additionalThemePacksHomeBase}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
              {extraThemePacks &&
                extraThemePacks.length > 0 &&
                extraThemePacks.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`optikTvExtraThemePack${roValue}`}>
                      <td>
                        {extraThemePack}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
                {extraThemePacksHomeBased &&
                extraThemePacksHomeBased.length > 0 &&
                extraThemePacksHomeBased.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`telusOptikTvExtraThemePackHomeBased${roValue}`}>
                      <td>
                        {extraThemePacksHomeBase}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
              {setTopBoxes &&
                setTopBoxes.length > 0 &&
                setTopBoxes.map(
                  ({
                    value: ltoValue,
                    qty: ltoQty,
                    prices: { oneTime: ltoOneTime, monthly: ltoMonthly } = {}
                  }) => (
                    <tr key={`optikTvSetupBoxes${ltoValue}`}>
                      <td>
                        {setTopBox}: {ltoValue}
                      </td>
                      <td>{ltoQty}</td>
                      <td>{formatPrice(ltoOneTime)}</td>
                      <td>{formatPrice(ltoMonthly)}</td>
                    </tr>
                  )
                )}
              {mainSetTopBoxValue && (
                <tr>
                  <td>
                    {mainSetTopBox}: {mainSetTopBoxValue}
                  </td>
                  <td>{mainSetTopBoxQty}</td>
                  <td>{formatPrice(mainSetTopBoxOneTime)}</td>
                  <td>{formatPrice(mainSetTopBoxMonthly)}</td>
                </tr>
              )}
              {additionalSetTopBoxes.map(
                (
                  {
                    value: additionalBoxValue,
                    qty: additionalBoxQty,
                    prices: {
                      monthly: additionalBoxMonthlyPrice,
                      oneTime: additionalBoxOneTimePrice
                    }
                  },
                  index
                ) => (
                  <tr>
                    <td>
                      {`${additionalSetTopBox} ${index + 1}`}:{' '}
                      {additionalBoxValue}
                    </td>
                    <td>{additionalBoxQty}</td>
                    <td>{formatPrice(additionalBoxOneTimePrice)}</td>
                    <td>{formatPrice(additionalBoxMonthlyPrice)}</td>
                  </tr>
                )
              )}
              {regularOffers &&
                regularOffers.length > 0 &&
                regularOffers.map(
                  ({
                    value: roValue,
                    qty: roQty,
                    prices: { oneTime: roOneTime, monthly: roMonthly } = {}
                  }) => (
                    <tr key={`optikTvRegularOffer${roValue}`}>
                      <td>
                        {regularOffer}: {roValue}
                      </td>
                      <td>{roQty}</td>
                      <td>{formatPrice(roOneTime)}</td>
                      <td>{formatPrice(roMonthly)}</td>
                    </tr>
                  )
                )}
              {limitedTimeOffers &&
                limitedTimeOffers.length > 0 &&
                limitedTimeOffers.map(
                  ({
                    value: ltoValue,
                    qty: ltoQty,
                    prices: { oneTime: ltoOneTime, monthly: ltoMonthly } = {}
                  }) => (
                    <tr key={`optikTvLimitedTimeOffer${ltoValue}`}>
                      <td>
                        {limitedTimeOffer}: {ltoValue}
                      </td>
                      <td>{ltoQty}</td>
                      <td>{formatPrice(ltoOneTime)}</td>
                      <td>{formatPrice(ltoMonthly)}</td>
                    </tr>
                  )
                )}
              <tr>
                <td>{total}</td>
                <td></td>
                <td>{formatPrice(totalOneTime)}</td>
                <td>{formatPrice(totalMonthly)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

OptikTv.defaultProps = {
  optikTv: {}
};

OptikTv.propTypes = {
  optikTv: PropTypes.objectOf(PropTypes.any)
};

export default OptikTv;
